import type { GatsbyBrowser } from 'gatsby';
import Layout from './src/components/Layout';
import { captureReferral, listenForSignupLinks } from './src/lib/referral';
import { captureAttribution } from './src/lib/attribution';
import './src/styles/site.css';
import './src/styles/content.css';
import './src/styles/hotshelf.css';
import './src/styles/screens.css';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => (
  <Layout pathname={props.location.pathname}>{element}</Layout>
);

// A link to another page starts at the top, at once. Gatsby already aims for the top, but the site-wide
// `scroll-behavior: smooth` turned that into a slow scroll that stopped short on long pages (footer links).
// Back/forward (no action) and #anchor links keep Gatsby's own handling.
export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({ routerProps }) => {
  const location = routerProps.location as typeof routerProps.location & { action?: string };
  if (location.action !== 'PUSH' || location.hash) return true;
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  return false;
};

// Ambassador links (`?ref=`): kept first-touch with no time limit and passed on to the app's sign-up.
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  // Where this visitor first came from, for sign-up attribution (first touch only).
  captureAttribution(window.location.search, document.referrer, window.location.pathname);
  captureReferral(window.location.search);
  listenForSignupLinks();
};
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  captureReferral(location.search);
};
